var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row gutter-x-lg items-center" }, [
      _c("div", { staticClass: "col-sm-auto col-12 gt-xs" }, [
        _c(
          "div",
          {
            staticClass: "bg-grey-1 circle text-center q-mr-lg",
            staticStyle: {
              height: "125px",
              width: "125px",
              "line-height": "125px"
            }
          },
          [
            _c("q-icon", {
              staticClass: "bg-grey-1 circle",
              attrs: { name: "local_mall", color: "grey-3", size: "100px" }
            })
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "col-sm col-12" },
        [
          _c(
            "q-field",
            {
              attrs: {
                error: _vm.errors.has("itemName"),
                "error-label": _vm.errors.first("itemName")
              }
            },
            [
              _c("q-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required|max:150",
                    expression: "'required|max:150'",
                    modifiers: { disable: true }
                  }
                ],
                ref: "itemName",
                staticClass: "items-form__name",
                attrs: { placeholder: _vm.$t("item_name"), name: "itemName" },
                model: {
                  value: _vm.formData.itemName,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "itemName", $$v)
                  },
                  expression: "formData.itemName"
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            {
              attrs: {
                error: _vm.errors.has("articleId"),
                "error-label": _vm.errors.first("articleId")
              }
            },
            [
              _c("q-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "max:45",
                    expression: "'max:45'",
                    modifiers: { disable: true }
                  }
                ],
                staticClass: "items-form__id",
                attrs: { placeholder: _vm.$t("article_id"), name: "articleId" },
                model: {
                  value: _vm.formData.itemNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "itemNumber", $$v)
                  },
                  expression: "formData.itemNumber"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _c("div", { staticClass: "row gutter-x-md q-mt-md" }, [
      _c(
        "div",
        { staticClass: "col-12 col-md-6" },
        [
          _c(
            "q-field",
            {
              attrs: {
                error: _vm.errors.has("price"),
                "error-label": _vm.errors.first("price")
              }
            },
            [
              _c("q-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required",
                    expression: "'required'",
                    modifiers: { disable: true }
                  }
                ],
                staticClass: "items-form__price",
                attrs: { placeholder: _vm.$t("price_net"), name: "price" },
                on: { input: _vm.priceUpdate },
                model: {
                  value: _vm.formData.price,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "price", $$v)
                  },
                  expression: "formData.price"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-12 col-md-6" },
        [
          _c(
            "q-field",
            {
              attrs: {
                error: _vm.errors.has("salesTax"),
                "error-label": _vm.errors.first("salesTax")
              }
            },
            [
              _c("sales-tax-input", {
                staticClass: "items-form__sales-tax",
                attrs: { "use-default": !_vm.isUpdate, required: "" },
                on: { input: _vm.handleTaxUpdate },
                model: {
                  value: _vm.formData.salesTax,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "salesTax", $$v)
                  },
                  expression: "formData.salesTax"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-12 col-md-6" },
        [
          _c(
            "q-field",
            {
              attrs: {
                error: _vm.errors.has("defaultQuantity"),
                "error-label": _vm.errors.first("defaultQuantity")
              }
            },
            [
              _c("q-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required",
                    expression: "'required'",
                    modifiers: { disable: true }
                  }
                ],
                staticClass: "items-form__defaultQuantity",
                attrs: {
                  placeholder: _vm.$t("default_quantity"),
                  name: "defaultQuantity"
                },
                model: {
                  value: _vm.formData.defaultQuantity,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "defaultQuantity", $$v)
                  },
                  expression: "formData.defaultQuantity"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-12 col-md-6" },
        [
          _c(
            "q-field",
            {
              attrs: {
                error: _vm.errors.has("unitName"),
                "error-label": _vm.errors.first("unitName")
              }
            },
            [
              _c(
                "q-input",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate.disable",
                      value: "required|max:45",
                      expression: "'required|max:45'",
                      modifiers: { disable: true }
                    }
                  ],
                  staticClass: "items-form__unitName",
                  attrs: { placeholder: _vm.$t("unit_name"), name: "unitName" },
                  model: {
                    value: _vm.formData.unitName,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "unitName", $$v)
                    },
                    expression: "formData.unitName"
                  }
                },
                [
                  _c("q-autocomplete", {
                    attrs: {
                      "static-data": { field: "label", list: _vm.defaultUnits },
                      "min-characters": 0
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]),
    _c(
      "div",
      { staticClass: "q-mt-lg q-mb-sm" },
      [
        _c("q-input", {
          attrs: {
            type: "textarea",
            placeholder: _vm.$t("description"),
            rows: "3"
          },
          model: {
            value: _vm.formData.description,
            callback: function($$v) {
              _vm.$set(_vm.formData, "description", $$v)
            },
            expression: "formData.description"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }